/* eslint-disable react-hooks/exhaustive-deps */
import { Column, Row } from "components/styles";
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
import TooltipButton from "components/TooltipButton/TooltipButton";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { handlerKeyPressOnlyNumbers } from "utils/validations";
import { MAX_LENGTH_FORM, TEXT_LIST_BY_FORM_ACTION_ERRORS } from "../utils/constants";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { AddressFields, CapacityFields, Container, HeaderFields } from "./styles";
import RequiredInformationForm from "components/RequiredInformationForm/RequiredInformationForm";
import ChangeHistory from "views/Configuracion/SettingsSpaceAdmin/components/RegisterSpaceForm/ChangeHistory/ChangeHistory";
import useDefaultAddress from "views/Configuracion/SettingsSpaceAdmin/utils/hooks/useDefaultAddress";
import useCapacityRangeError from "views/Configuracion/SettingsSpaceAdmin/utils/hooks/useCapacityRangeError";
import useAvailableActivitiesBySpaceType from "../utils/hooks/useAvailableActivitiesBySpaceType";
import AvailableActivitiesField from "./AvailableActivitiesField";
import useDashboardContext from "routes/utils/context/useDashboardContext";

const RegisterSpaceFormFields = ({
    className, data: {
        campusList,
        spaceTypeList,
        universityActivityList
    }, 
    formHandler, toggleActiveHandler, 
    spaceSelected, spaceChangeHistory
}) => {
    const { userCampusId } = useDashboardContext();
    const isUpdate = !spaceSelected.isEmpty();
    const {
        form, errors
    } = formHandler;
    const { 
        campusId, spaceTypeId, name,
        minCapacity, maxCapacity, 
        address, reference,
        spaceOutOfCampus, details, active 
    } = form.value;
    const universityActivityListBySpaceType = useAvailableActivitiesBySpaceType({
        universityActivityList, form
    })
    useCapacityRangeError({
        formHandler
    });
    useDefaultAddress({
        form, campusList, isUpdate
    });
    const noAddress = !isUpdate && !campusId;
    return (
        <Container className={className}>
            <HeaderFields>
                <CustomSelect 
                    label="Campus"
                    value={campusId}
                    optionsProps={getOptionsToCustomSelect(campusList, { id: "id", text: "name" })}
                    onChange={form.setCampus}
                    defaultOptionText="Elige un Campus"
                    disabled={isUpdate || userCampusId}
                    required/>
                <CustomSelect 
                    label="Tipo de espacio"
                    value={spaceTypeId}
                    optionsProps={getOptionsToCustomSelect(spaceTypeList, { id: "id", text: "name" })}
                    onChange={form.setSpaceType}
                    defaultOptionText="Elige un Espacio"
                    disabled={isUpdate}
                    required/>
                <CustomTextInput 
                    label="Nombre del espacio"
                    placeholder="Indica el nombre del ambiente"
                    value={name}
                    onChange={form.setName}
                    maxLength={MAX_LENGTH_FORM.name}
                    required/>
            </HeaderFields>
            <Row width="100%" justifyContent="flex-start" align="flex-start">
                <AvailableActivitiesField
                    data={{
                        spaceTypeList,
                        universityActivityList: universityActivityListBySpaceType
                    }}
                    form={form}/>
                <CapacityFields>
                    <Row justifyContent="flex-start" width="100%">
                        <CustomTextInput 
                            label="Aforo mínimo"
                            placeholder="Indica el Aforo mínimo"
                            value={minCapacity}
                            onChange={form.setMinCapacity}
                            onKeyPress={handlerKeyPressOnlyNumbers}
                            maxLength={MAX_LENGTH_FORM.minCapacity}
                            error={errors.value.capacityRange}
                            required/>
                        <CustomTextInput 
                            label="Aforo máximo"
                            placeholder="Indica el Aforo máximo"
                            value={maxCapacity}
                            onChange={form.setMaxCapacity}
                            onKeyPress={handlerKeyPressOnlyNumbers}
                            maxLength={MAX_LENGTH_FORM.maxCapacity}
                            error={errors.value.capacityRange}
                            required/>
                    </Row>
                    <ErrorMessage 
                        text={TEXT_LIST_BY_FORM_ACTION_ERRORS.CAPACITY_RANGE}
                        error={errors.value.capacityRange}/>
                </CapacityFields>
            </Row>
            <AddressFields>
                <Column width="unset">
                    <CustomTextInput 
                        width="100%"
                        label="Dirección"
                        placeholder={noAddress || !spaceOutOfCampus ? "-" : "Indica una dirección"}
                        value={address}
                        onChange={form.setAddress}
                        maxLength={MAX_LENGTH_FORM.address}
                        disabled={!spaceOutOfCampus}
                        required/>                
                    <CustomCheckbox 
                        label="El espacio se encuentra fuera del campus"
                        checked={spaceOutOfCampus}
                        onChange={form.toggleSpaceOutOfCampus}
                        padding="0"
                        disabled={noAddress}/>
                </Column>
                <CustomTextInput 
                    label="Referencia"
                    placeholder="Indica una referencia"
                    value={reference}
                    onChange={form.setReference}
                    maxLength={MAX_LENGTH_FORM.reference}
                    required/>
            </AddressFields>
            <CustomTextArea 
                label="Detalles"
                placeholder="Escribe algunos detalles a considerar sobre el espacio"
                value={details}
                onChange={form.setDetails}
                height="60px"
                showCharCounter={false} 
                maxLength={MAX_LENGTH_FORM.details}/>
            {!spaceSelected.isEmpty() &&
            <Row width="100%">
                <Row justifyContent="flex-start" gap="5px">
                    <CustomCheckbox 
                        variant="switch"
                        size="10px" 
                        label="Activo"
                        labelColor="var(--light-gray-4)"
                        checked={active}
                        onChange={toggleActiveHandler.toggleActiveFromField}/>
                    <TooltipButton
                        message="Recuerda que podrás activar o desactivar el espacio."/>
                </Row>
                <Column width="max-content" align="flex-end">
                    <ChangeHistory spaceChangeHistory={spaceChangeHistory}/>
                    <RequiredInformationForm/>
                </Column>
            </Row>}
        </Container>
    );
}

export default RegisterSpaceFormFields;